import { Component, ElementRef, Inject, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { SalespersonService } from '../../../core/services/salesperson.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { fuseAnimations } from '../../../../@fuse/animations';

@Component({
  selector: 'app-modal-sales-person',
  templateUrl: './modal-sales-person.component.html',
  styleUrls: ['./modal-sales-person.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None
})
export class ModalSalesPersonComponent implements OnInit {

  @ViewChild(MatPaginator, {static: true})
  paginator: MatPaginator;

  @ViewChild('filter', {static: true})
  filter: ElementRef;

  @ViewChild(MatSort, {static: true})
  sort: MatSort;

  displayedColumns = ['citizenId', 'name', 'position', 'action'];

  dataSource: {
    model: any[];
  };

  tableSource: any;

  constructor(private _salespersonService: SalespersonService,
              public _dialogRef: MatDialogRef<ModalSalesPersonComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any = {}) {
  }

  ngOnInit(): void {
    this.dataSource = {
      model: []
    };

    this.getSalePerson();
  }

  getSalePerson(): any {
    this.dataSource = {
      model: []
    };

    this._salespersonService.getSalespersons(this.data.companyId)
      .toPromise()
      .then(res => {
        this.dataSource.model = res.model;// .filter(i => i.branchId === this.data.branchId); // เอาออกชั่วคราว
        this.tableSource = new MatTableDataSource(this.dataSource.model);
        this.tableSource.sort = this.sort;
        this.tableSource.paginator = this.paginator;
      });
  }

  applyFilter(value: string): any {
    this.tableSource.filter = value.trim().toLowerCase();
  }

  onSelected(item): void {
    this._dialogRef.close(item);
  }

  onClose() {
    this._dialogRef.close(null);
  }
}
